import moment from "moment";
import {ServiceStatus} from "@/enums/ServiceStatus";

export default {
  name: "RequestBookingAppointment",
  data() {
    return {
      period: 4,
      start: moment(new Date()),
      end: moment(new Date()).add(4, 'days'),
      selectedDate: null,
      selectedTime: null,
      panel: null,
    }
  },
  props: ['selectedService', 'serviceRequests'],
  computed: {
    morning() {
      return this.generateTimeSlots(this.selectedDate?.availableHours.open, '11:59');
    },
    afternoon() {
      return this.generateTimeSlots('12:00', '16:59');
    },
    evening() {
      return this.generateTimeSlots('17:00', this.selectedDate?.availableHours.close);
    },
    durationDates() {
      return `${this.start.format("MMM")} ${this.start.format("DD")}-${this.end.format("DD")}, ${this.start.format("YYYY")}`;
    },
    durationTimeRequest() {
      if(this.selectedDate?.date && this.selectedTime?.start && this.selectedTime?.end) {
        return {
          startTime: moment(`${this.selectedTime?.start} ${this.selectedDate?.date}`, 'HH:mm DD/MM/YYYY').toDate(),
          endTime: moment(`${this.selectedTime?.end} ${this.selectedDate?.date}`, 'HH:mm DD/MM/YYYY').toDate(),
        }
      }
    },
    requestsSelectedService() {
      return this.serviceRequests
        .filter(request => request.serviceId === this.selectedService.id)
        .filter(request => [
          ServiceStatus.AwaitingApproval,
          ServiceStatus.Approved,
          ServiceStatus.Completed,
        ].includes(request.status))
    },
    activeTimeSlots() {
      const result = [];

      this.requestsSelectedService.forEach(request => {
        if(request?.startTime && request?.endTime) {
          const date = moment(request?.startTime.seconds * 1000).format("DD/MM/YYYY");
          const startHours = moment(request?.startTime.seconds * 1000).format("HH:mm");
          const endHours = moment(request?.endTime.seconds * 1000).format("HH:mm");

          if(result.find(x => x.date === date)) {
            const day = result.find(x => x.date === date);

            if(day.slots.find(slot => slot.start === startHours) && day.slots.find(slot => slot.end === endHours)) {
              const slot = day.slots.find(slot => slot.start === startHours);

              slot.count++;
            } else {
              day.slots.push({ start: startHours, end: endHours, count: 1 });
            }
          } else {
            result.push({ date: date, slots: [{ start: startHours, end: endHours, count: 1 }] });
          }
        }
      });

      return result;
    },
    dates() {
      const startMoment = moment(this.start);
      const endMoment = moment(this.end);
      const daysList = [];

      while (startMoment.isSameOrBefore(endMoment, 'day')) {
        const day = startMoment.format('dddd').toLowerCase();
        const isDisabled = startMoment.isBefore(moment(new Date()).subtract(1, 'day'));

        const availableHours: any = {};
        this.selectedService.availableHours[day].forEach(x => {
          if(x.isOpen) {
            if(availableHours.open && availableHours.close) {
              const open = moment(x.open, "HHmm");
              const close = moment(x.close, "HHmm");
              const openExists = moment(availableHours.open, "HHmm");
              const closeExists = moment(availableHours.close, "HHmm");

              if(open.isBefore(openExists)) {
                availableHours.open = moment(x.open, "HHmm").format("HH:mm");
              }

              if(closeExists.isBefore(close)) {
                availableHours.close = moment(x.close, "HHmm").format("HH:mm");
              }

            } else {
              availableHours.open = moment(x.open, "HHmm").format("HH:mm");
              availableHours.close = moment(x.close, "HHmm").format("HH:mm");
            }
          }
        });

        daysList.push({
          date: startMoment.format('DD/MM/YYYY'),
          day: day.slice(0, 3).toUpperCase(),
          number: startMoment.format('DD'),
          availableHours: availableHours,
          isDisable: isDisabled || (Object.keys(availableHours).length === 0)
        });

        startMoment.add(1, 'day');
      }

      return daysList;
    },
  },
  methods: {
    generateTimeSlots(start: string, end: string) {
      const slots = [];
      const startMoment = moment(start, 'HH:mm');
      const endMoment = moment(end, 'HH:mm');
      const interval = this.selectedService.slotDurationInMins;

      while (startMoment.isBefore(endMoment)) {
        const startTime = startMoment.format('HH:mm');
        const endTime = startMoment.add(interval, 'minutes').format('HH:mm');
        const slot = {
          start: startTime,
          end: endTime,
          disable: false
        };

        if(this.activeTimeSlots.find(day => day.date === this.selectedDate?.date)) {
          const day = this.activeTimeSlots.find(day => day.date === this.selectedDate?.date);

          if(day.slots.find(slot => slot.start === startTime) && day.slots.find(slot => slot.end === endTime)) {
            const currentSlot = day.slots.find(slot => slot.start === startTime);

            if(currentSlot.count === this.selectedService.maxSlots) {
              slot.disable = true;
            }
          }
        }

        slots.push(slot);
      }

      return slots;
    },
    prev() {
      this.start = moment(this.start).subtract(this.period + 1, 'days');
      this.end = moment(this.start).add(this.period, 'days');
      this.$emit('resetDurationTime');
    },
    next() {
      this.start = moment(this.start).add(this.period + 1, 'days');
      this.end = moment(this.start).add(this.period, 'days');
      this.$emit('resetDurationTime');
    }
  },
  watch: {
    durationTimeRequest(value) {
      if(value) {
        this.$emit('setDurationTime', this.durationTimeRequest)
      }
    },
  }
}